import React from "react";
import logoicn from "../../../assets/images/clio.logolong.png";
const LogoIcon = (props) => {
  return <img alt="Logo" src={logoicn} style={{ width: "100%", height: "auto", marginLeft: "0px" }} />;
};

export default LogoIcon;
